/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Terminaldeactivated1Inputs */

const tr_auth_terminaldeactivated1 = /** @type {(inputs: Auth_Terminaldeactivated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu terminal yetkilendirmesi sonlandırıldı. Yeniden aktifleştirilmesi gerekiyor.`)
};

const en_auth_terminaldeactivated1 = /** @type {(inputs: Auth_Terminaldeactivated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This terminal authorization has been terminated. It needs to be reactivated.`)
};

/**
* | output |
* | --- |
* | "This terminal authorization has been terminated. It needs to be reactivated." |
*
* @param {Auth_Terminaldeactivated1Inputs} inputs
* @param {{ locale?: "tr" | "en" }} options
* @returns {LocalizedString}
*/
const auth_terminaldeactivated1 = /** @type {((inputs?: Auth_Terminaldeactivated1Inputs, options?: { locale?: "tr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Terminaldeactivated1Inputs, { locale?: "tr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "tr") return tr_auth_terminaldeactivated1(inputs)
	return en_auth_terminaldeactivated1(inputs)
});
export { auth_terminaldeactivated1 as "auth_terminalDeactivated" }